import { render, staticRenderFns } from "./TechFile.vue?vue&type=template&id=102d1f52&"
import script from "./TechFile.vue?vue&type=script&lang=js&"
export * from "./TechFile.vue?vue&type=script&lang=js&"
import style0 from "./TechFile.vue?vue&type=style&index=0&id=102d1f52&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports